export class ResizeManager {
    static eventListeners = [];
    static EVENTS = {
        RESIZE: "resize",
        REFRESH: "refresh"
    };

    static addEventListener(callback, context) {
        ResizeManager.eventListeners.push({ callback, context });
    }

    static removeEventListener(callback, context) {
        for (let i = 0; i < ResizeManager.eventListeners.length; i++) {
            if (ResizeManager.eventListeners[i].callback === callback && ResizeManager.eventListeners[i].context === context) {
                // Remove single entry from array, and return immediately
                // as continuing iteration is unsafe, as the underlying array
                // has been modified
                ResizeManager.eventListeners.splice(i, 1);
                return;
            }
        }
    }

    static init() {
        $(window).resize(() => {
            ResizeManager._resize();
        });
    }

    static refresh() {
        ResizeManager._updateSizes();
        ResizeManager._notifyEventListeners(ResizeManager.EVENTS.REFRESH, null);
    }

    static _resize() {
        ResizeManager._updateSizes();
        ResizeManager._notifyEventListeners(ResizeManager.EVENTS.RESIZE, null);
    }

    static _updateSizes() {
        $("#game").width($("#mainContent").width() + 20);
        $("#game").height(Math.min($(window).height(), Math.floor($("#game").width() * 0.75)));
        $("#playerPanel").width($("#mainContent").width() + 20);
        $("#playerPanel").height(Math.min(180, Math.floor($("#playerPanel").width() * 0.25)));
        $("#scrapyardSnippet .content").height($("#scrapyardSnippet .content").width() * 0.185);
    }

    static _notifyEventListeners(evt, data) {
        for (let i = 0; i < ResizeManager.eventListeners.length; i++) {
            ResizeManager.eventListeners[i].callback(ResizeManager.eventListeners[i].context, evt, data);
        }
    }
}
